import React from "react";
import { Link } from "react-router";

import GenericBlackBtn from "./GenericBlackBtn";

export default function (props) {
    let style = props.style || {};
    return (
        <Link to="/" style={style}>
            <GenericBlackBtn>
                <span className="glyphicon glyphicon-home" />
            </GenericBlackBtn>
        </Link>
    );
}



// WEBPACK FOOTER //
// ./src/js/HomeBtn.js